export interface ILoadable<T> {
  value: T;
  isLoading: boolean;
}

export function toLoadable<T>(arr: T[]): ILoadable<T>[] {
  return arr.map((value) => ({ value, isLoading: false }));
}
